export function formatPhoneroUsername(phoneNumber: string): string {
  const digits = phoneNumber.replace(/\D/g, '');

  if (digits.startsWith('47') && digits.length === 10) {
    return digits.slice(2);
  }

  return digits;
}
